module.exports = __webpack_public_path__ + "static/media/ropewalk-shopping-centre-transforming-nuneaton.98e7eae7.jpg";